<div class="copo-container settings-general">
	<div class="button-container" *ngIf="enableManageServices">
		<button type="button" mat-button color="accent"
			class="organization-button"
			(click)="goToManageService()"><span class="text-color" translate>settings.manage-services </span>
			<mat-icon iconPositionEnd svgIcon="md:edit" class="icon-color"></mat-icon>
		</button>
	</div>
	<div class="card-block">
		<div class="card-title">
			<div class="card-title-label" translate>services.management</div>
		</div>
		<div class="copo-card-grid-container">
			<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions" [modules]="modules"
			(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
		</div>
	</div>
</div>